import { showAlert } from './alerts.js';

document.addEventListener('DOMContentLoaded', function () {
  console.log('Hello from dealsHandler !');

  function createDeal(
    user,
    store,
    product,
    storephone,
    link,
    productname,
    productprice,
    productDevise,
    storename
  ) {
    const encodedStoreName = storename;
    const encodedProductPrice = productprice;
    const encodedProductName = productname;
    const encodedLink = link;

    const message = `Bonjour ${encodedStoreName},

Je suis intéressé par votre annonce sur HelixDeal :

Produit : *${encodedProductName}*
Prix : ${encodedProductPrice} ${productDevise}
Lien : ${encodedLink}

Est-ce toujours disponible ?`;

    const url = `https://wa.me/${storephone}?text=${encodeURIComponent(message)}`;

    // setTimeout(() => {
    //   location.assign(url);
    // }, 500);
    axios
      .post(`/api/v1/deals`, { user, store, product })
      .then(function (res) {
        if (res.data.status === 'success') {
          showAlert(
            'info',
            'Super !',
            'Vous allez être redirigé vers le WhatsApp du vendeur pour finaliser le Deal.'
          );
          location.assign(url, '_blank');
        }
      })
      .catch(function (err) {
        showAlert('danger', 'Alert', err.response.data);
      });
  }

  const dealBtn = document.getElementById('dealBtn');
  const dealBtns = document.getElementsByClassName('dealBtn');

  if (dealBtn) {
    dealBtn.addEventListener('click', function (e) {
      const user = this.getAttribute('data-user');
      // const name = this.getAttribute("data-name");
      const store = this.getAttribute('data-store');
      const product = this.getAttribute('data-product');
      const storephone = this.getAttribute('data-storephone');
      const productprice = this.getAttribute('data-productprice');
      const productDevise = this.getAttribute('data-productdevise');
      const productname = this.getAttribute('data-productname');
      const productslug = this.getAttribute('data-productslug');
      const storename = this.getAttribute('data-storename');

      const link = `${window.location.href}`;

      createDeal(
        user,
        store,
        product,
        storephone,
        link,
        productname,
        productprice,
        productDevise,
        storename
      );
    });
  }

  // $(dealBtns).dblclick(false);
  if (dealBtns.length > 0) {
    Array.from(dealBtns).forEach(function (dealBtn) {
      $(dealBtn).on('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        // this.addClass("is-loading");
        // setTimeout(() => {
        //   this.removeClass("is-loading");
        // }, 1500);
        const user = this.getAttribute('data-user');
        // const name = this.getAttribute("data-name");
        const productThumbnail = this.getAttribute('data-productthumbnail');
        const productCategory = this.getAttribute('data-productcategory');
        const store = this.getAttribute('data-store');
        const product = this.getAttribute('data-product');
        const storephone = this.getAttribute('data-storephone');

        const productname = this.getAttribute('data-productname');
        const productprice = this.getAttribute('data-productprice');
        const productDevise = this.getAttribute('data-productdevise');
        const productslug = this.getAttribute('data-productslug');
        const storename = this.getAttribute('data-storename');

        const link = `${window.location.origin}/product/${productslug}?category=${encodeURIComponent(productCategory)}&thumbnail=${encodeURIComponent(productThumbnail)}`;
        createDeal(
          user,
          store,
          product,
          storephone,
          link,
          productname,
          productprice,
          productDevise,
          storename
        );
      });
    });
  }

  // Initialize LightSlider with left-side gallery layout
  $('#lightSlider').lightSlider({
    // gallery: true,
    item: 1,
    controls: true,
    loop: true,
    slideMargin: 0,
    thumbItem: 0, // Disable built-in thumbnails since we have custom ones
    enableTouch: true,
    enableDrag: true,
    freeMove: true,
    swipeThreshold: 40,
    currentPagerPosition: 'middle',
    keyPress: true,
    vertical: false,
    adaptiveHeight: true,
    onSliderLoad: function (el) {
      // Custom thumbnail navigation
      $('.thumbnail-btn').on('click', function () {
        const index = $(this).data('index');
        el.goToSlide(index);
        $('.thumbnail-btn')
          .removeClass('border-indigo-500')
          .addClass('border-transparent');
        $(this).removeClass('border-transparent').addClass('border-indigo-500');
      });

      // Initialize first thumbnail as active
      $('.thumbnail-btn')
        .first()
        .removeClass('border-transparent')
        .addClass('border-indigo-500');
    },
    onAfterSlide: function (el) {
      // Update active thumbnail
      const currentIndex = el.getCurrentSlideCount();
      $('.thumbnail-btn')
        .removeClass('border-indigo-500')
        .addClass('border-transparent');
      $(`.thumbnail-btn[data-index="${currentIndex}"]`)
        .removeClass('border-transparent')
        .addClass('border-indigo-500');
    },
  });
});
